<div class="-oneX-container">
    <div class="-oneX-container">
        <div class="-oneX-row">
            <div class="-oneX-heading--h1">Claim Found </div>
        </div>
    </div>
    <hr>
    <div class="-oneX-container">
        <div class="-oneX-row -oneX-justify-content-center">
            <div class="-oneX-container">   
                <app-claim-information></app-claim-information>     
            </div>
        </div>
        <hr>
        <div class="-oneX-row -oneX-justify-content-center">
            <div class="-oneX-container">   
                <app-claim-handler></app-claim-handler>     
            </div>
        </div>
        <hr>
        <div class="-oneX-row -oneX-justify-content-center">
            <div class="-oneX-container"> 
                <app-payment-details></app-payment-details>
            </div>
        </div>
        <hr>
        <div class="-oneX-row -oneX-justify-content-center">
            <div class="-oneX-container"> 
                <app-search-another-claim></app-search-another-claim>
            </div>
        </div>
    </div>
</div>